import _ from 'lodash';

import { root } from '../../selectors';

export const getReviewIncAppsState = (state) =>
  _.get(root(state), 'ReviewIncomingApps', null);

export const getSavedReviewAppGridState = (state) =>
  _.get(getReviewIncAppsState(state), 'ReviewAppGrid', null);

export const getSavedReviewDuplicatesModalState = (state) =>
  _.get(getReviewIncAppsState(state), 'ReviewDuplicatesModal', null);



// WEBPACK FOOTER //
// ./src/state/pagestatecache/pages/reviewincomingapplications/selectors.js